import { dashboard } from "../../../telemetry/TraceLogging";
import { lazyLoadModule } from "../../lazyLoadModule";
const TelemetryModule = import(
/* webpackChunkName: "Telemetry-Chunk" */
"../../../telemetry/Telemetry");
export class ViewChangedApi {
    constructor() {
        this._lastView = "halfView";
        this._eventListeners = new Array();
    }
    addEventListener(listener) {
        this._eventListeners.push(listener);
    }
    removeEventListener(listener) {
        let index = this._eventListeners.indexOf(listener);
        if (index > -1) {
            this._eventListeners.splice(index, 1);
        }
    }
    fireViewChangedEvent(view) {
        this._lastView = view;
        this.fireEvent("viewChanged", view);
    }
    getView() {
        return this._lastView;
    }
    fireEvent(name, view) {
        lazyLoadModule(TelemetryModule).then((Telemetry) => {
            Telemetry.logEvent(dashboard, "ViewChangedEvent", 33554432 /* productAndServiceUsage */, {
                eventType: name,
                view: view,
            });
        });
        for (let index = 0; index < this._eventListeners.length; index++) {
            if (this._eventListeners[index]) {
                this._eventListeners[index](name, view);
            }
        }
    }
}
